import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ProblemHeaderProps {
  title: string;
  onClose: () => void;
}

const ProblemHeader: React.FC<ProblemHeaderProps> = ({ title, onClose }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
    <Typography variant="h5">{title}</Typography>
    <IconButton onClick={onClose} size="small">
      <CloseIcon />
    </IconButton>
  </Box>
);

export default ProblemHeader;
